export default "__VITE_ASSET__X$5781zp__"